import { Component, Inject, OnInit } from '@angular/core';
import { ChangeLogService } from '../../service/changelog.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ChangeLog,
  ChangeReviewStatus,
  ChangeSource,
} from '../../model/changelog';
import { ChangelogUtil } from '../../util/changelog-util';
import { BaseDirective } from '@egym/ngx-adm-int';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'gymfinder-changelog-details',
  templateUrl: './changelog-details.component.html',
  styleUrls: ['./changelog-details.component.scss'],
  standalone: false,
})
export class ChangelogDetailsComponent
  extends BaseDirective<void>
  implements OnInit
{
  constructor(
    snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ChangelogDetailsComponent>,
    private changeLogService: ChangeLogService,
    @Inject(MAT_DIALOG_DATA) private data: ChangeLog
  ) {
    super(snackBar);
  }

  changelog: ChangeLog;

  fieldsCount: number;

  displayedColumns: string[] = ['field', 'oldValue', 'newValue'];

  ngOnInit(): void {
    this.changelog = this.formatChangeLog(this.data);
    this.fieldsCount = this.changelog.metadata.length;
  }

  formatChangeLog(changelog: ChangeLog) {
    return {
      ...changelog,
      metadata: changelog.metadata.map(m => ChangelogUtil.formatChangeLogValues(m)),
    };
  }

  closeDialog(reload?: boolean) {
    this.dialogRef.close(reload);
  }

  canBeMarkedAsViewed() {
    return (
      this.changelog.reviewStatus === ChangeReviewStatus.NOT_VIEWED &&
      this.changelog.source === ChangeSource.PARTNER_PORTAL
    );
  }

  markAsViewed() {
    this.changeLogService.markAsViewed(this.changelog.id).subscribe({
      next: () => {
        this.closeDialog(true);
      },
      error: () => {
        this.openSnackBar('Cannot mark this changelog as viewed.');
      },
    });
  }
}
